export default __webpack_public_path__ + "static/media/ID.2e61c096.png";